import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private oAuthService: OAuthService) {}

  canActivate(): boolean {
    console.log("canActivate")
    if (this.oAuthService.hasValidAccessToken()) {
      console.log("canActivate 11")
      return true;
    }
    this.oAuthService.initLoginFlow();
    console.log("canActivate 22")
    return false;
  }

  canActivateChild(): boolean {
    return this.canActivate();
  }
}
